export default class Pits {
	side = 'right';
	entry = '';
	start = '';
	end = '';
	exit = '';
	length = 0;
	width = 0;
}